import { useState } from "react";
import { Header, SideBar } from "./imports";
import "./Dashboard.css";

const Dashboard = ({ mainComponent }) => {
    const [sideBarVisibility, setSideBarVisibility] = useState(false);
    
    let showHideSideBar = () => {
        setSideBarVisibility(!sideBarVisibility);
    };

    return (
        <div className="dashboard">
            <Header showHideSideBar={showHideSideBar} />
            <SideBar sideBarVisibility={sideBarVisibility} />
            <div className="main">{mainComponent}</div>
        </div>
    );
};

export default Dashboard;
